import { useAppAction, useAppSelector } from '../hooks';
import {
  CompanyManagementFetchMyCompanyThunk,
  UserManagementAddManyUsersFromFileThunk,
  UserManagementAddUserThunk,
  UserManagementEditUserThunk,
  UserManagementRemoveUserThunk,
  companyManagementEditCompanyThunk,
  companyManagementFetchCompaniesThunk,
  companyManagementFetchUsersPermissionsThunk,
  companyManagementFetchUsersThunk,
  companyManagementGenerateInvitationLinkThunk,
  companyManagementUpdateUserPermissionThunk,
  companyManagementUpdateUserStatusThunk,
  companyManagementUploadImageThunk,
} from './companyManagementActions';
import { COMPANY_MANAGEMENT_NAMESPACE } from './companyManagementReducer';
import { CompanyManagementState } from './companyManagementTypes';

export function useCompanyManagementSelector<
  T extends (state: CompanyManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[COMPANY_MANAGEMENT_NAMESPACE])
  );
}

export const useCompanyManagementCompanies = () =>
  useCompanyManagementSelector((state) => {
    return state.companies;
  });

export const useCompanyManagementCompanyTypes = () =>
  useCompanyManagementSelector((state) => {
    return state.companyTypes;
  });

export const useCompanyManagementGetCompanyById = (id: number) =>
  useCompanyManagementSelector((state) => {
    return state.companies.find((company) => company.id === id);
  });

export const useCompanyManagementMyCompany = () =>
  useCompanyManagementSelector((state) => {
    return state.company;
  });

export const useCompanyManagementGetCompanyUsers = () =>
  useCompanyManagementSelector((state) => {
    return state.companyUsers;
  });

export const useCompanyManagementUsers = () =>
  useCompanyManagementSelector((state) => {
    return state.users;
  });

export const useCompanyManagementGetUserById = (id: number) =>
  useCompanyManagementSelector((state) => {
    return state.companyUsers.find((user) => user.id === id);
  });

export const useCompanyManagementGetMyCompany = () =>
  useCompanyManagementSelector((state) => {
    return state.company;
  });

export const useCompanyManagementUpdateCompany = () =>
  useAppAction(companyManagementEditCompanyThunk);

export const useFetchCompanyManagementCompanies = () =>
  useAppAction(companyManagementFetchCompaniesThunk);

export const useCompanyManagementUploadImage = () =>
  useAppAction(companyManagementUploadImageThunk);

export const useCompanyManagementSetCompanyUsers = () =>
  useAppAction(companyManagementFetchUsersPermissionsThunk);

export const useCompanyManagementUpdateUserStatus = () =>
  useAppAction(companyManagementUpdateUserStatusThunk);

export const useCompanyManagementUpdateUserPermission = () =>
  useAppAction(companyManagementUpdateUserPermissionThunk);

export const useFetchMyCompanyUsers = () =>
  useAppAction(companyManagementFetchUsersThunk);

export const useCompanyManagementAddManyUsersFromFile = () =>
  useAppAction(UserManagementAddManyUsersFromFileThunk);

export const useUserManagementRemoveUser = () =>
  useAppAction(UserManagementRemoveUserThunk);

export const useUserManagementUpdateUser = () =>
  useAppAction(UserManagementEditUserThunk);

export const useUserManagementAddNewUser = () =>
  useAppAction(UserManagementAddUserThunk);

export const useFetchMyCompany = () =>
  useAppAction(CompanyManagementFetchMyCompanyThunk);

export const useGenerateInvitationLink = () =>
  useAppAction(companyManagementGenerateInvitationLinkThunk);
